import React, { CSSProperties } from 'react'
import styled from 'styled-components'

import { ColorsSchemeNames } from '../colors'
import { DirectionType, RenderAnimationType } from './lib/types'
import { timingFunc } from '../timing-func'
import { opacityBackgroundCss } from '../backgrounds'
import { absoluteLayer } from '../absolute-layer'
import { TransitionStatus } from 'react-transition-group'

const getTransitionStyles = ({
	direction = 'left',
	delay = 0.5,
	time = 0.5,
}: {
	direction: DirectionType
	delay: string | number
	time: string | number
	size: string | number
}) => {
	const transition = `clip-path ${time}s ${delay ? delay + 's' : ''} ${
		timingFunc.easeOutCubic
	}`

	let initial: CSSProperties
	let final: CSSProperties

	if (direction === 'top') {
		initial = {
			clipPath: 'polygon(0 0, 100% 0%, 100% 100%, 0 100%)',
		}
		final = { clipPath: 'polygon(0 100%, 100% 100%, 100% 100%, 0 100%)' }
	}
	if (direction === 'bottom') {
		initial = {
			clipPath: 'polygon(0 0, 100% 0%, 100% 100%, 0 100%)',
		}
		final = { clipPath: 'polygon(0 0, 100% 0, 100% 0, 0 0)' }
	}
	if (direction === 'left') {
		initial = {
			clipPath: 'polygon(0 0, 100% 0%, 100% 100%, 0 100%)',
		}
		final = { clipPath: 'polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)' }
	}
	if (direction === 'right') {
		initial = {
			clipPath: 'polygon(0 0, 100% 0%, 100% 100%, 0 100%)',
		}
		final = { clipPath: 'polygon(0 0, 0 0%, 0 100%, 0 100%)' }
	}

	return {
		entering: {
			transition,
			...final,
		},
		entered: {
			transition,
			...final,
			zIndex: -1,
		},
		exiting: {
			transition,
			...initial,
		},
		exited: {
			transition,
			...initial,
		},
	}
}

export const renderDisclosure: RenderAnimationType<{ contentType?: boolean }> =
	({
		bgColor = 'gray-01',
		bgImage,
		children,
		className,
		key,
		ref,
		contentType,
		...props
	}) => {
		const getStyle = (state: TransitionStatus) =>
			getTransitionStyles(props)[state]

		return state => {
			return (
				<Wrapper ref={ref} key={key} className={className}>
					{children}
					<Overlay
						bgImage={bgImage}
						bgColor={bgColor}
						style={getStyle(state)}
						contentType={contentType}
					/>
				</Wrapper>
			)
		}
	}

const Overlay = styled.div<{
	bgImage?: string
	bgColor: ColorsSchemeNames
	contentType?: boolean
}>`
	${absoluteLayer}
	z-index: 400;
	margin: ${({ contentType }) => (contentType ? '-5px' : null)};
	${opacityBackgroundCss}
`
const Wrapper = styled.div`
	/* overflow: hidden; */
	position: relative;
`
